import React from 'react';
import Titulo from '../comum/Titulo';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { showSuccessMsg } from '../../util/messagesUtil';
import { bindActionCreators } from 'redux';
import cadastrarConfiguracaoExcessoBagagem from '../../actions/empresa/cadastrarConfiguracaoExcessoBagagem';
import buscarConfiguracaoExcessoBagagem from '../../actions/empresa/buscarConfiguracaoExcessoBagagem';
import {
    maxValueMonetario,
    renderFieldMonetarioLabelEncima,
    renderFieldPercentLabelEncima,
    maxValueMonetarioPercentual,
    required,
} from '../../util/inputs';

const SectionCard = ({ icon, title, subtitle, children }) => (
    <div className="vx-config-card">
        <div className="vx-config-card-header">
            <i className="material-icons">{icon}</i>
            <div className="vx-config-card-header-text">
                <h6>{title}</h6>
                {subtitle && <small>{subtitle}</small>}
            </div>
        </div>
        <div className="vx-config-card-body">
            {children}
        </div>
    </div>
);

const renderToggle = ({ input }) => (
    <label className="vx-switch" style={{ cursor: 'pointer', flexShrink: 0 }}>
        <input {...input} type="checkbox" />
        <span className="vx-switch-slider" />
    </label>
);

export class PainelConfiguracaoExcessoBagagem extends React.Component {
    constructor(props) {
        super(props);
        this.salvar = this.salvar.bind(this);
    }

    componentDidMount() {
        if (this.props.empresaSelecionada.id) {
            this.props.buscarConfiguracaoExcessoBagagem(this.props.empresaSelecionada.id);
        }
    }

    montarParametros() {
        return {
            id: this.props.id,
            habilitadoPrecoKg: this.props.habilitadoPrecoKg,
            precoKg: this.props.habilitadoPrecoKg ? this.props.precoKg.replace('R$', '') : null,
            habilitadoPrecoFixoMaisValorKg: this.props.habilitadoPrecoFixoMaisValorKg,
            precoFixo: this.props.habilitadoPrecoFixoMaisValorKg ? this.props.precoFixo.replace('R$', '') : null,
            valorKg: this.props.habilitadoPrecoFixoMaisValorKg ? this.props.valorKg.replace('R$', '') : null,
            habilitadoPrecoMetroCubico: this.props.habilitadoPrecoMetroCubico,
            precoMetroCubico: this.props.habilitadoPrecoMetroCubico ? this.props.precoMetroCubico.replace('R$', '') : null,
            habilitadoTaxaSeguro: this.props.habilitadoTaxaSeguro,
            taxaSeguro: this.props.habilitadoTaxaSeguro ? this.props.taxaSeguro.replace('R$', '') : null,
            mensagem: this.props.mensagem,
        };
    }

    salvar() {
        this.props.cadastrarConfiguracaoExcessoBagagem(
            this.props.empresaSelecionada.id,
            this.montarParametros()
        ).then(() => {
            showSuccessMsg('Configuração salva com sucesso');
        });
    }

    render() {
        const { invalid, pristine } = this.props;

        return (
            <div className="container-padrao">
                <Titulo texto="Configuração de Excesso de Bagagem" urlRetorno="/menu-bagagem" />

                <form className="vx-config-page">

                    {/* ── Cobrança por Peso ── */}
                    <SectionCard icon="scale" title="Cobrança por Peso" subtitle="Defina as regras de precificação do excesso de bagagem">

                        {/* Preço por Kg */}
                        <div className="vx-toggle-row">
                            <div className="vx-toggle-info">
                                <div className="vx-toggle-info-title">Preço por Kg</div>
                                <div className="vx-toggle-info-desc">Cobra um valor fixo por quilograma excedente</div>
                            </div>
                            <Field name="habilitadoPrecoKg" type="checkbox" component={renderToggle} />
                        </div>
                        {this.props.habilitadoPrecoKg && (
                            <div className="vx-toggle-sub" style={{ maxWidth: 240 }}>
                                <Field
                                    name="precoKg"
                                    validate={[maxValueMonetario, required]}
                                    component={renderFieldMonetarioLabelEncima}
                                    label="Preço do Kg:"
                                />
                            </div>
                        )}

                        {/* Preço Fixo + Kg */}
                        <div className="vx-toggle-row">
                            <div className="vx-toggle-info">
                                <div className="vx-toggle-info-title">Preço Fixo + Preço por Kg</div>
                                <div className="vx-toggle-info-desc">Cobra uma taxa fixa de abertura mais um valor por Kg adicional</div>
                            </div>
                            <Field name="habilitadoPrecoFixoMaisValorKg" type="checkbox" component={renderToggle} />
                        </div>
                        {this.props.habilitadoPrecoFixoMaisValorKg && (
                            <div className="vx-toggle-sub">
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, maxWidth: 500 }}>
                                    <Field
                                        name="precoFixo"
                                        validate={[maxValueMonetario, required]}
                                        component={renderFieldMonetarioLabelEncima}
                                        label="Taxa fixa:"
                                    />
                                    <Field
                                        name="valorKg"
                                        validate={[maxValueMonetario, required]}
                                        component={renderFieldMonetarioLabelEncima}
                                        label="Preço do Kg adicional:"
                                    />
                                </div>
                            </div>
                        )}

                        {/* Metro Cúbico */}
                        <div className="vx-toggle-row">
                            <div className="vx-toggle-info">
                                <div className="vx-toggle-info-title">Preço por Metro Cúbico (M³)</div>
                                <div className="vx-toggle-info-desc">Cobra com base no volume da carga em metros cúbicos</div>
                            </div>
                            <Field name="habilitadoPrecoMetroCubico" type="checkbox" component={renderToggle} />
                        </div>
                        {this.props.habilitadoPrecoMetroCubico && (
                            <div className="vx-toggle-sub" style={{ maxWidth: 240 }}>
                                <Field
                                    name="precoMetroCubico"
                                    validate={[maxValueMonetario, required]}
                                    component={renderFieldMonetarioLabelEncima}
                                    label="Preço por M³:"
                                />
                            </div>
                        )}
                    </SectionCard>

                    {/* ── Taxa de Seguro ── */}
                    <SectionCard icon="security" title="Taxa de Seguro" subtitle="Percentual sobre o valor declarado ou nota fiscal">
                        <div className="vx-toggle-row">
                            <div className="vx-toggle-info">
                                <div className="vx-toggle-info-title">Habilitar Taxa de Seguro</div>
                                <div className="vx-toggle-info-desc">Adiciona um percentual de seguro ao valor do pedido</div>
                            </div>
                            <Field name="habilitadoTaxaSeguro" type="checkbox" component={renderToggle} />
                        </div>
                        {this.props.habilitadoTaxaSeguro && (
                            <div className="vx-toggle-sub">
                                <div style={{ maxWidth: 240, marginBottom: 10 }}>
                                    <Field
                                        name="taxaSeguro"
                                        validate={[maxValueMonetarioPercentual, required]}
                                        component={renderFieldPercentLabelEncima}
                                        label="Taxa do Seguro (%):"
                                        maxLength={5}
                                    />
                                </div>
                                <p style={{ fontSize: 12, color: '#888', margin: 0, lineHeight: 1.5 }}>
                                    <i className="material-icons" style={{ fontSize: 13, verticalAlign: 'middle', marginRight: 4 }}>info_outline</i>
                                    O seguro será calculado sobre o valor da nota fiscal ou do valor declarado e adicionado ao total do pedido.
                                </p>
                            </div>
                        )}
                    </SectionCard>

                    {/* ── Mensagem da Via Remetente ── */}
                    <SectionCard icon="description" title="Mensagem da Via Remetente" subtitle="Texto impresso na via do remetente (até 2000 caracteres)">
                        <Field
                            id="mensagemExcessoBagagem"
                            name="mensagem"
                            component="textarea"
                            className="form-control"
                            style={{ minHeight: 110, resize: 'vertical', fontSize: 13 }}
                            placeholder="Escreva a mensagem que será impressa na via do remetente..."
                            maxLength={2000}
                        />
                        {this.props.mensagem && (
                            <div style={{ fontSize: 11, color: '#aaa', marginTop: 4, textAlign: 'right' }}>
                                {(this.props.mensagem || '').length} / 2000
                            </div>
                        )}
                    </SectionCard>

                    {/* ── Save bar ── */}
                    <div className="vx-config-save-bar">
                        <span className="vx-config-save-hint">
                            <i className="material-icons">info_outline</i>
                            Apenas uma modalidade de cobrança deve ser habilitada por vez
                        </span>
                        <button
                            type="button"
                            className="btn btn-laranja vx-config-save-btn"
                            onClick={this.salvar}
                            disabled={invalid || pristine}
                        >
                            <i className="material-icons">save</i>
                            Salvar Configuração
                        </button>
                    </div>

                </form>
            </div>
        );
    }
}

export const mapStateToProps = state => ({
    initialValues: {
        id: state.configuracaoExcessoBagagem.id,
        habilitadoPrecoKg: state.configuracaoExcessoBagagem.habilitadoPrecoKg,
        precoKg: state.configuracaoExcessoBagagem.precoKg,
        habilitadoPrecoFixoMaisValorKg: state.configuracaoExcessoBagagem.habilitadoPrecoFixoMaisValorKg,
        valorKg: state.configuracaoExcessoBagagem.valorKg,
        precoFixo: state.configuracaoExcessoBagagem.precoFixo,
        habilitadoPrecoMetroCubico: state.configuracaoExcessoBagagem.habilitadoPrecoMetroCubico,
        precoMetroCubico: state.configuracaoExcessoBagagem.precoMetroCubico,
        habilitadoTaxaSeguro: state.configuracaoExcessoBagagem.habilitadoTaxaSeguro,
        taxaSeguro: state.configuracaoExcessoBagagem.taxaSeguro,
        mensagem: state.configuracaoExcessoBagagem.mensagem,
    },
    empresaSelecionada: state.empresaSelecionada,
    habilitadoPrecoKg: formValueSelector('formularioCadastroConfiguracaoExcessoBagagem')(state, 'habilitadoPrecoKg'),
    precoKg: formValueSelector('formularioCadastroConfiguracaoExcessoBagagem')(state, 'precoKg'),
    habilitadoPrecoFixoMaisValorKg: formValueSelector('formularioCadastroConfiguracaoExcessoBagagem')(state, 'habilitadoPrecoFixoMaisValorKg'),
    valorKg: formValueSelector('formularioCadastroConfiguracaoExcessoBagagem')(state, 'valorKg'),
    precoFixo: formValueSelector('formularioCadastroConfiguracaoExcessoBagagem')(state, 'precoFixo'),
    habilitadoTaxaSeguro: formValueSelector('formularioCadastroConfiguracaoExcessoBagagem')(state, 'habilitadoTaxaSeguro'),
    habilitadoPrecoMetroCubico: formValueSelector('formularioCadastroConfiguracaoExcessoBagagem')(state, 'habilitadoPrecoMetroCubico'),
    precoMetroCubico: formValueSelector('formularioCadastroConfiguracaoExcessoBagagem')(state, 'precoMetroCubico'),
    taxaSeguro: formValueSelector('formularioCadastroConfiguracaoExcessoBagagem')(state, 'taxaSeguro'),
    mensagem: formValueSelector('formularioCadastroConfiguracaoExcessoBagagem')(state, 'mensagem'),
    id: state.configuracaoExcessoBagagem.id,
});

export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        cadastrarConfiguracaoExcessoBagagem,
        buscarConfiguracaoExcessoBagagem,
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioCadastroConfiguracaoExcessoBagagem',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(PainelConfiguracaoExcessoBagagem));
